import useBaseMessageAsyncError from './useBaseMessageAsyncError';
import useMessage from './useMessage';

function useMessageAsyncError() {
  return useBaseMessageAsyncError({ hook: useMessage });
}

export default useMessageAsyncError;
